import { Injectable }    from '@angular/core';
import {
    Response, Http, Headers,
    URLSearchParams
} from '@angular/http';
import {RestResponse, RequestConfig} from './rest.request'
import {Observable} from "rxjs";
import Logger from "log4ts/build/Logger";
import {IAppender} from "log4ts/build/IAppender";
import {ILayout} from "log4ts/build/ILayout";
import LoggerConfig from "log4ts/build/LoggerConfig";
import BasicLayout from "log4ts/build/layouts/BasicLayout";
import ConsoleAppender from "log4ts/build/appenders/ConsoleAppender";
import {LogLevel} from "log4ts/build/LogLevel";
import {isNullOrUndefined} from "util";
import {TokenManager} from "../../+login/auth.service";
import {environment} from "../../../environments/environment";

@Injectable()
export class LogService{

    public log: Logger;

    private appender: IAppender;
    private layout: ILayout;
    private config: LoggerConfig;

    constructor() {
        this.init();
    }

    init(){
        this.layout = new BasicLayout();
        this.appender = new ConsoleAppender();
        this.appender.setLayout(this.layout);
        this.config = new LoggerConfig(this.appender);
        this.config.setLevel(LogLevel.ALL);
        this.log = new Logger();
        Logger.setConfig(this.config);
    }

    info(message:string){
        this.log.info(message);
    }

    debug(message:string){
        this.log.debug(message);
    }

    error(message:string){
        this.log.error(message);
    }
}

@Injectable()
export class RestService {

    url:string=environment.api_url;
    public token:TokenManager;
    constructor(private http:Http,private log:LogService){
    }

    extractData(res:Response){
        let body = res.json();
        return body.data || {};
    }

    sendLogin(username:string,password:string):any {
        /*let body:URLSearchParams = new URLSearchParams();
        body.append("grant_type","password");
        body.append("client_id",environment.client_id);
        body.append("client_secret",environment.client_secret);
        body.append("username",username);
        body.append("password",password);

        var headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');

        return this.http.post(environment.oauth_server,body, headers);*/
    }
    refreshToken():any {
        /*let body:URLSearchParams = new URLSearchParams();
        body.append("grant_type","refresh_token");
        body.append("client_id",environment.client_id);
        body.append("refresh_token",this.token.refresh_token);
        body.append("client_secret",environment.client_secret);
        var headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(environment.oauth_server,body,headers);*/
    }

    getConfig(code:string){
    }

    handleError(error:Response | any){
        var errorResponse:RestResponse;
        if(error instanceof Response){
            const body = error.json();
            errorResponse = new RestResponse(body.code,error.status,body.message,body.errorList);
        }else{
            errorResponse = new RestResponse("ERRDESC",error.status,"Error al enviar peticion",[]);
        }
        return Observable.throw(errorResponse).toPromise();
    }

    /**
     * Envia una petición al sevidor y regresa un promise
     * @param code codigo para buscar la configuración de la petición
     * @param extraPath parametros extra por url
     * @param body objeto json a ser enviado al servidor, solo para peticiones de tipo POST y PUT
     */
    sendRequest(code:string,extraPath:string,body?:any,...pathVariables):any{

    }

    getUrl():string{
        return this.url;
    }

    getFormattedUrl(url:string,...pathVariables){
        let size = url.indexOf('{');
        if(!isNullOrUndefined(pathVariables) && pathVariables.length>0 && size>0 && pathVariables.length){
            pathVariables.forEach(variable=>{
                variable.forEach(path=>{
                    let index = url.indexOf('{');
                    let limit = url.indexOf('}') +1;
                    url = url.substr(0,index) + path + url.substr(limit,url.length);
                });
            });
        }
        return url;
    }
}
